import { useState } from "react";
import { Link } from "react-router-dom";
import asicflow_logo from '../assets/img/logos/asicflow_logo.png';
import {api} from '../../api.js'

function PasswordReset() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setMsg(""); // clear previous message

    if (!email) {
      setMsg("❌ Please enter your email address.");
      return;
    }

    try {
      const res = await api.forgot({ email });
      const data = await res.json();

      if (res.ok) {
        setMsg("✅ Password reset email sent! Check your inbox.");
      } else {
        setMsg(`❌ ${data.error || "Failed to send reset email."}`);
      }
    } catch (err) {
      console.error(err);
      setMsg("❌ Server error. Please try again later.");
    }
  };

  return (
    <section className="bg-secondary py-3 py-md-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4">
            <div className="card border border-light-subtle rounded-3 shadow-sm">
              <div className="card-body p-3 p-md-4 p-xl-5">

                <div className="text-center mb-3">
                  <Link to="/">
                    <img src={asicflow_logo} alt="AsicFlow Logo" width={300} />
                  </Link>
                </div>

                <h2 className="fs-6 fw-normal text-center text-secondary mb-4">
                  Provide the email address associated with your account to recover
                  your password.
                </h2>

                {/* Message Display Area */}
                {msg && (
                  <div
                    className={`alert ${
                      msg.startsWith("✅") ? "alert-success" : "alert-danger"
                    } alert-dismissible fade show`}
                    role="alert"
                  >
                    {msg}
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setMsg("")}
                      aria-label="Close"
                    ></button>
                  </div>
                )}

                <form>
                  <div className="row gy-2 overflow-hidden">
                    <div className="col-12">
                      <div className="form-floating">
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder="name@example.com"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                        <label htmlFor="email">Email</label>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="d-grid my-3">
                        <button className="btn btn-primary btn-lg" type="button" onClick={submit}>
                          Reset Password
                        </button>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="d-flex gap-2 justify-content-between">
                        <Link to="/login" className="link-primary text-decoration-none">
                          Log In
                        </Link>
                        <Link to="/signup" className="link-primary text-decoration-none">
                          Register
                        </Link>
                      </div>
                    </div>
                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PasswordReset;
